export default __webpack_public_path__ + "static/media/profile1.ce812b0d.png";